import { useColorModeValue } from '@chakra-ui/react';

export const useColors = () => {
  const bgColor = useColorModeValue('white', 'navy.800');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const textColor = useColorModeValue('gray.700', 'gray.200');
  const headingColor = useColorModeValue('navy.700', 'white');

  const errorColor = useColorModeValue('red.500', 'red.300');
  const hoverBg = useColorModeValue('gray.50', 'whiteAlpha.100');
  const hoverColor = useColorModeValue('blue.500', 'blue.300');

  return {
    bgColor,
    borderColor,
    textColor,
    headingColor,
    errorColor,
    hoverBg,
    hoverColor,
  };
};
